import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, Heading, HeadingPriority, HeadingType, Text, TextSize } from '@as/cotopaxi';
import { SearchResultsExecutionStatusEnums, } from '@as-react/common-types';
const INITIAL_QUERY_PLACEHOLDER = '{{{INITIAL QUERY}}}';
const ALTERNATIVE_BRAND_PLACEHOLDER = '{{{ALTERNATIVE BRAND}}}';
const PartialSearchResultsTitles = ({ alternativeBrand, maybeMeant, maybeLike, executionStatus, alternativeQueryResults, initialSearchTerm, }) => {
    const getSuggestedSearchTerm = () => alternativeQueryResults[0].alternativeQuery;
    const getTitles = () => {
        let titles = [];
        switch (executionStatus) {
            case SearchResultsExecutionStatusEnums.ALT_BRAND:
                titles = alternativeBrand.title.split(ALTERNATIVE_BRAND_PLACEHOLDER);
                titles[0] = titles[0].replace(INITIAL_QUERY_PLACEHOLDER, initialSearchTerm);
                titles[1] = getSuggestedSearchTerm();
                return titles;
            case SearchResultsExecutionStatusEnums.ALT_QUERIES:
                titles = maybeMeant.title.split(INITIAL_QUERY_PLACEHOLDER);
                titles.splice(1, 0, initialSearchTerm);
                return titles;
            case SearchResultsExecutionStatusEnums.ALT_SPELL_UNCHANGED:
                titles = maybeLike.title.split(INITIAL_QUERY_PLACEHOLDER);
                titles.splice(1, 0, initialSearchTerm);
                return titles;
        }
        return titles;
    };
    const getDescription = () => {
        switch (executionStatus) {
            case SearchResultsExecutionStatusEnums.ALT_BRAND:
                return alternativeBrand.description.replace(ALTERNATIVE_BRAND_PLACEHOLDER, getSuggestedSearchTerm());
            case SearchResultsExecutionStatusEnums.ALT_QUERIES:
                return maybeMeant.description;
            case SearchResultsExecutionStatusEnums.ALT_SPELL_UNCHANGED:
                return maybeLike.description;
            default:
                return '';
        }
    };
    return (_jsxs(_Fragment, { children: [_jsx(Box, { desktop: { spacing: { marginTop: 0, marginBottom: 2 } }, tablet: { spacing: { marginTop: 2, marginBottom: 2 } }, mobile: { spacing: { marginTop: 2, marginBottom: 2 } }, children: _jsxs(Heading, { priority: HeadingPriority.H1, type: HeadingType.EXTRA_TITLE, children: [getTitles()[0], getTitles()[1] && (_jsxs(Text, { inline: true, size: TextSize.INHERIT, children: ["\u201C", getTitles()[1], "\u201D"] })), getTitles()[2]] }) }), _jsx(Text, { emphasized: true, size: TextSize.MEDIUM, children: getDescription() })] }));
};
export { PartialSearchResultsTitles };
